import { Component, Input } from '@angular/core';
import { RefDeliveryinformation } from 'src/app/model/refDeliveryinformation.model';

@Component({
  selector: 'app-opening-hours',
  templateUrl: './opening-hours.component.html',
  styleUrls: ['./opening-hours.component.scss']
})
export class OpeningHoursComponent {

  @Input() refDeliveryinformation: RefDeliveryinformation;

  constructor() { }

  formatingHours(date:string) {
    return date.replace(":", "h");
  }
}
